import { ChartOptions } from 'chart.js';

import { Renewables } from './types';

export const HYDRO_FUEL_TYPES = ['PS', 'NPSHYD'];
export const NON_HYDRO_RENEWABLES = ['WIND', 'SOLAR'];

export const OTHER_BG_COLOR = 'rgba(249, 250, 251, 0.32)';

export const CHART_OPTIONS: ChartOptions<'doughnut'> = {
  animation: false,
  maintainAspectRatio: false,
  responsive: true,
};

export const LABELS: Record<string, string> = {
  [Renewables.ALL_HYDRO]: 'Hydro',
  [Renewables.SOLAR]: 'Solar',
  [Renewables.WIND]: 'Wind',
};
